import { TokenClient } from '../TokenClient';
import { TokenRoutes } from '../TokenRoutes';

/**
 * Shorthand to TokenClient({ url: TokenRoutes.PUBLIC_ACCESS })
 */
export class PublicTokenClient extends TokenClient {
  constructor() {
    super({
      url: TokenRoutes.PUBLIC_ACCESS
    });
  }
}
//# sourceMappingURL=PublicTokenClient.js.map